import { APP_VERSION } from '@/app/app-version';

interface DeveloperCreditProps {
  className?: string;
}

export function DeveloperCredit({ className = '' }: DeveloperCreditProps) {
  const classes = ['developer-credit', className].filter(Boolean).join(' ');

  return (
    <footer className={classes} aria-label="توقيع المطور" dir="rtl">
      <div className="developer-credit-main" dir="ltr">
        <bdi dir="ltr" lang="en">Concept &amp; Development</bdi>
        <strong>
          <bdi dir="ltr" lang="en">Mohamed Hasan</bdi>
        </strong>
      </div>
      <span className="developer-credit-rights" dir="ltr" lang="en">
        © 2026 All Rights Reserved · Version {APP_VERSION}
      </span>
    </footer>
  );
}
